var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagLine = function SvgFlagLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.7 15.6V21H3.9V3.9h8.444a.9.9 0 0 1 .804.498L13.8 5.7h5.4a.9.9 0 0 1 .9.9v9.9a.9.9 0 0 1-.9.9h-5.744a.9.9 0 0 1-.804-.497L12 15.6zm0-9.9v8.1h7.412l.9 1.8H18.3V7.5h-5.612l-.9-1.8z"
  })));
};
export default SvgFlagLine;